/* global axios */
import ApiClient from './ApiClient';

class InternalChatAPI extends ApiClient {
  constructor() {
    super('internal_chat', { accountScoped: true });
  }

  getUsers(query = '') {
    const params = {};
    if (query?.trim()) {
      params.query = query.trim();
    }

    return axios.get(`${this.url}/users`, { params });
  }

  getThreads() {
    return axios.get(`${this.url}/threads`);
  }

  getThread(threadId) {
    return axios.get(`${this.url}/threads/${threadId}`);
  }

  createThread(recipientId) {
    return axios.post(`${this.url}/threads`, {
      recipient_id: recipientId,
    });
  }

  createGroupThread({ groupName, memberIds, groupAvatar = null }) {
    if (groupAvatar) {
      const formData = new FormData();
      formData.append('is_group', 'true');
      formData.append('group_name', groupName);
      memberIds.forEach(memberId => {
        formData.append('member_ids[]', memberId);
      });
      formData.append('group_avatar', groupAvatar);
      return axios.post(`${this.url}/threads`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }

    return axios.post(`${this.url}/threads`, {
      is_group: true,
      group_name: groupName,
      member_ids: memberIds,
    });
  }

  getMessages(threadId, page = 1, sinceId = null) {
    const params = { page };
    if (sinceId) params.since_id = sinceId;
    return axios.get(`${this.url}/threads/${threadId}/messages`, { params });
  }

  sendMessage(threadId, content, attachments = []) {
    if (attachments.length > 0) {
      const formData = new FormData();
      if (content) formData.append('content', content);
      attachments.forEach(file => {
        formData.append('attachments[]', file);
      });
      return axios.post(
        `${this.url}/threads/${threadId}/messages`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
    }
    return axios.post(`${this.url}/threads/${threadId}/messages`, {
      content,
    });
  }

  markRead(threadId) {
    return axios.post(`${this.url}/threads/${threadId}/read`);
  }

  leaveThread(threadId) {
    return axios.post(`${this.url}/threads/${threadId}/leave`);
  }

  hideThread(threadId) {
    return axios.post(`${this.url}/threads/${threadId}/hide`);
  }

  addMembers(threadId, memberIds) {
    return axios.post(`${this.url}/threads/${threadId}/add_members`, {
      member_ids: memberIds,
    });
  }
}

export default new InternalChatAPI();
